import {Tooltip} from '@material-ui/core';
import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

type RecordStatusProps = {
  count: number;
};

export const SuccessfulRecords = ({count}: RecordStatusProps) => {
  return (
    <div className="record-status">
      <Tooltip title={`# of successful record(s):${count}`}>
        <CheckCircleIcon className="status__successful" />
      </Tooltip>
      <span className="record-count">{count}</span>
    </div>
  );
};

export default SuccessfulRecords;
